import type { DataSource, ModelTable } from './dataModelsTypes';

export const FILE_CONNECTOR_KEYS = new Set(['google-drive', 'onedrive']);

export function connectorKeyOf(source?: DataSource | null): string {
  return String(source?.connectorKey || '').trim().toLowerCase();
}

export function isFileConnector(source?: DataSource | null): boolean {
  return FILE_CONNECTOR_KEYS.has(connectorKeyOf(source));
}

export function isFileAsset(table: Pick<ModelTable, 'assetKind'>, source?: DataSource | null): boolean {
  if (table.assetKind === 'File') return true;
  return isFileConnector(source);
}

export function fileAssetId(table: Pick<ModelTable, 'path' | 'name'>): string {
  return String(table.path || table.name || '').trim();
}

export function assetTypeLabel(table: Pick<ModelTable, 'assetKind'>, source?: DataSource | null): string {
  if (isFileAsset(table, source)) return 'File';
  if (table.assetKind === 'Collection') return 'Collection';
  if (table.assetKind === 'View') return 'View';
  return 'Table';
}
